import "babel-polyfill";

import jQuery from "jquery";

window.$ = window.jQuery = $ = jQuery;

import "bootstrap";
import "slick-lightbox";
import "slick-carousel";
import "sticky-kit/dist/sticky-kit.js";
import enquire from "enquire.js";

// import "waypoints/src/waypoint";
// import "vendor/waypoints_sticky";

// import Swiper, {SwiperOptions} from "@dmitryn/swiperjs/src/swiper";
// const swiper = new Swiper('.swiper', {
//   speed: 400,
//   spaceBetween: 100,
// });


$(document).ready(() => {
  'use strict';

  $(".js-slick-lightbox").slickLightbox({
    itemSelector: "> a"
  });


  $('.slick-carousel').slick({
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    arrows: true,
    fade: true,
    // cssEase: 'linear',
    mobileFirst: true,
  });


  // var $ = window.jQuery;
  // var waypoint = window.Waypoint;

  // var waypoints = $('.header').waypoint(function (direction) {
  //     // handler: function (direction) {
  //     // console.log('direction', direction);
  //     // console.log(this.element.id + ' hit');
  //     if (direction == 'down') {
  //
  //         console.log('direction', direction);
  //         console.log(this.element.id + ' hit');
  //
  //         // $(".header").stick_in_parent({
  //         //     offset_top: 100,
  //         //     parent: ".js-sticky-wrapper",
  //         //     spacer: ".js-sticky-spacer"
  //         // });
  //     } else {
  //     }
  //
  // }, {
  //     offset: 4
  // });


  // $(".header__wrapper").stick_in_parent({
  //     offset_top: 0,
  //     parent: "body",
  //     spacer: ".header"
  // });


  // $(".js-stick-to-parent.portfolio-title-fix-class").stick_in_parent(({offset_top: 64, parent: ".section-wrapper", spacer: ".sticky-spacer"}))
  //   .on("sticky_kit:bottom", function (e) {
  //     $(this).addClass("it-is-bottom");
  //   })
  //   .on("sticky_kit:unbottom", function (e) {
  //     $(this).removeClass("it-is-bottom");
  //   });


  // var window_width = $( window ).width();
  //
  // if (window_width < 992) {
  //     $(".js-sticky").trigger("sticky_kit:detach");
  // } else {
  //     make_sticky();
  // }
  //
  // $( window ).resize(function() {
  //
  //     window_width = jQuery( window ).width();
  //
  //     if (window_width < 992) {
  //         $(".js-sticky").trigger("sticky_kit:detach");
  //     } else {
  //         make_sticky();
  //     }
  //
  // });
  //
  // function make_sticky() {
  //     $(".js-sticky").stick_in_parent({
  //         offset_top: 100,
  //         parent: ".js-sticky-wrapper",
  //         spacer: ".js-sticky-spacer"
  //     });
  // }


  $(".wpcf7-response-output").remove();

  function setCookie(name, value, days) {
    if (!days) {
      days = 365 * 20;
    }
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

    var expires = "; expires=" + date.toUTCString();

    document.cookie = name + "=" + value + expires + "; path=/";
  }

  function getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  $('.js-cookie-bar-button').click(function (e) {
    setCookie('cookie_notification_dismissed', true);
    $('.cookie-bar').fadeOut();
  });


  document.addEventListener('wpcf7mailsent', function (event) {
    $('.form__modal').fadeIn();
  }, false);


  function scrollToSection(locHash) {
    var scrollToPos = $(locHash).offset().top;
    var offsetAdd = 30;
    if ($('.navbar__toggler').hasClass('is-active')) {
      offsetAdd = 20;
    }

    if (scrollToPos > 0) {
      scrollToPos = scrollToPos - offsetAdd;
    }
    $('html, body').animate({
      scrollTop: scrollToPos,
    }, 500);
  }

  $('[data-scroll]').on('click', function (e) {
    e.preventDefault();
    if ($('.navbar__toggler').hasClass('is-active')) {
      $('.navbar-collapse').collapse('hide');
    }
    scrollToSection($($(this).attr('data-scroll-target')));
  });

  // Scroll to position on page load
  const locHash = location.hash.replace('#', '#_');
  if ($(locHash).length) {
    setTimeout(function () {
      scrollToSection(locHash);
    }, 1);
  }

  $('.form__modal-close, .form__modal').click(function (e) {
    e.preventDefault();
    $('.form__modal').fadeOut();
  });


  $('.navbar-collapse').on('show.bs.collapse', function () {
    $('body').addClass('no--scroll');
    $('.navbar__toggler').addClass('is-active');
  });

  $('.navbar-collapse').on('hide.bs.collapse', function () {
    $('body').removeClass('no--scroll');
    $('.navbar__toggler').removeClass('is-active');
  });

});

// Your scripts here
